module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_60m.Reinforced_Concrete.8989c9b5.png";